var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#marker)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 15.5,
    r: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 1C14.2765 1 8 7.61992 8 15.7656C8 18.5219 8.72349 21.2044 10.1001 23.5177L21.051 42.4188C21.2378 42.7388 21.5178 42.9357 21.8445 42.9849C22.2877 43.0587 22.7779 42.8619 23.0345 42.3943L34.0167 23.3207C35.3233 21.0567 36 18.4235 36 15.7656C36 7.61992 29.7235 1 22 1ZM22 23.1484C18.0802 23.1484 15 19.8016 15 15.7656C15 11.705 18.1499 8.38282 22 8.38282C25.8501 8.38282 29 11.705 29 15.7656C29 19.777 25.9666 23.1484 22 23.1484Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6183 42.6695L20.6192 42.671C20.8732 43.106 21.2757 43.4036 21.766 43.4787C22.405 43.5836 23.1059 43.2986 23.4702 42.6397L34.4498 23.5706C34.4499 23.5705 34.4499 23.5705 34.45 23.5704C35.8024 21.2267 36.5 18.5068 36.5 15.7656C36.5 7.3692 30.0244 0.5 22 0.5C13.9756 0.5 7.5 7.3692 7.5 15.7656C7.5 18.608 8.24581 21.3784 9.66891 23.7709C9.66941 23.7717 9.6699 23.7725 9.6704 23.7734L20.6183 42.6695ZM22 22.6484C18.3853 22.6484 15.5 19.5553 15.5 15.7656C15.5 11.9557 18.4508 8.88282 22 8.88282C25.5492 8.88282 28.5 11.9557 28.5 15.7656C28.5 19.5341 25.6583 22.6484 22 22.6484Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22 1V8.38288C25.8501 8.38288 29 11.7051 29 15.7658C29 19.7771 25.9666 23.1486 22 23.1486V42.9997C22.3981 43.0094 22.8076 42.8081 23.0344 42.3947L34.0167 23.3209C35.3233 21.0569 36 18.4237 36 15.7658C36 7.61998 29.7235 1 22 1Z",
    fill: "#5A617A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 0,
    width: 38,
    height: 51.9998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498039 0 0 0 0 0.458824 0 0 0 0 0.839216 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "marker"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/ToolTip.7f8abba991485be9d10d27b3dc25cceb.svg";
export { ForwardRef as ReactComponent };